// src/pages/sangamam/sangamamThankyou.jsx
import React, { useEffect, useState } from "react";
import HomeBanner from "../../assets/images/sangamam_1.jpg";
import Banner from "../../components/header/banner";
import "./sangamamThankyou.css";

/**
 * Landing page shown after a successful submit of the Sangamam
 * enquiry form. Reuses the exact same banner image/component as the
 * Thiruporur/Sangamam page, with a centered "Thank you" message
 * below it. Sized to fit the viewport with no vertical scrollbar —
 * see sangamamThankyou.css for how the banner height is constrained,
 * and footercontainer.jsx for how the global footer is hidden only
 * on this route.
 */
export const SangamamThankYou = () => {
  const [availableHeight, setAvailableHeight] = useState(null);

  useEffect(() => {
    const calcHeight = () => {
      const navEl = document.querySelector(".nav-header-lap");
      const navHeight = navEl ? navEl.offsetHeight : 0;
      setAvailableHeight(window.innerHeight - navHeight);
    };
    calcHeight();
    window.addEventListener("resize", calcHeight);
    return () => window.removeEventListener("resize", calcHeight);
  }, []);

  // Google Ads "Purchase" conversion — fires once whenever someone
  // lands on this page (gtag.js is already loaded globally in
  // public/index.html, so we just call the existing window.gtag).
  // This is separate from the "lead" conversion fired on form submit
  // in enquiryForm.jsx — different conversion label, both intentional.
  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-16666240151/u9oyCLrq2tQcEJfJios-",
        value: 1.0,
        currency: "INR",
        transaction_id: "",
      });
    }
  }, []);

  return (
    <div
      className="sangamam-thankyou-page"
      style={availableHeight ? { height: `${availableHeight}px` } : undefined}
    >
      <Banner bannerImgSrc={HomeBanner} />
      <div className="sangamam-thankyou-text">
        <h1>Thank you for visiting us</h1>
      </div>
    </div>
  );
};

export default SangamamThankYou;
